import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import getMastermindLink from "../../../../common/helpers/getMasterminLink";
import { pluralize } from "../../../../common/helpers/helpers";
import {
  getQuery,
  getVariantResult,
  getVariantId,
} from "../../../../state/selectors/general.selectors";
import HelperText from "../../../atoms/HelperText";

// coppied from old component.
function MasterMind({ variantResult, variantId, query }) {
  if (!variantResult || !variantId) {
    return null;
  }
  const nvr = variantResult;
  const masterminds = getMastermindLink(nvr, window.location.hostname, "-pub");
  return masterminds ? (
    <>
      {masterminds.map((mm, i) => {
        let links = "";
        if (mm.identifiers.length > 0) {
          const filteredArray = mm.identifiers.filter(
            (indentifier) => indentifier.identifier === query
          );
          const indentifiers = filteredArray.length
            ? filteredArray
            : mm.identifiers;
          links = indentifiers.map((identifier, k) => {
            return k === indentifiers.length - 1 ? (
              <span key={k}>
                <a href={identifier.url} target="_blank">
                  {identifier.identifier.toUpperCase()}
                </a>
              </span>
            ) : (
              <span key={k}>
                <a href={identifier.url} target="_blank">
                  {identifier.identifier.toUpperCase()} ,{" "}
                </a>
              </span>
            );
          });
        }
        return (
          <div
            className="varsome-inner-container varsome-text-center tw-mt-4"
            key={i}
          >
            Mastermind
            <HelperText fieldDescriptionKey="Mastermind" /> found {mm.mmcnt}{" "}
            full-text {pluralize(mm.mmcnt, "article", "articles")} related to{" "}
            {links}
          </div>
        );
      })}
    </>
  ) : null;
}

MasterMind.propTypes = {
  variantResult: PropTypes.shape({}),
  variantId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  query: PropTypes.string,
};

MasterMind.defaultProps = {
  variantResult: null,
  variantId: null,
  query: "",
};

const mapStateToProps = (state) => {
  return {
    variantResult: getVariantResult(state),
    variantId: getVariantId(state),
    query: getQuery(state),
  };
};

export default connect(mapStateToProps, {})(React.memo(MasterMind));
